export default {
    current_choice: 'Elección actual',
    book_now: 'Reservar ahora',
    minimum_age: 'Solo mayores de {age} años',
    excess_liability: 'Responsabilidad por daños',
    security_deposit: 'Depósito de seguridad',
    fuel_policy: 'Política de combustible',
    like_for_like: 'Igual por igual',
    full_to_full: 'Lleno a lleno',
    miles_per_rental: '{mileage} millas gratis por alquiler',
    km_per_rental: '{mileage} km gratis por alquiler',
    unlimited_mileage: 'Kilometraje ilimitado',
    unlimited_mileage_km: 'Km ilimitados',
    non_amendable: 'No modificable',
    non_refundable: 'No reembolsable',
    free_cancellation_until: 'Cancelación gratuita hasta',
    basic_free_cancellation: 'Cancelación gratuita hasta 48 horas antes de la hora de inicio',
    cancellation_in_line_with: 'Cancelación de acuerdo con',
    tcs: 'Términos y condiciones',
    free_extras_on_collection: 'Dos extras gratis al recoger',
    glass_and_tyres_covered: 'Cristales y neumáticos cubiertos',
    number_of_passengers: 'Número de pasajeros',
    number_of_bags: 'Número de maletas',
    fuel_type: 'Tipo de combustible',
    co2: 'CO2',
    aircon: 'Aire acondicionado',
    transmission: 'Transmisión',
    book_type: 'Reservar {type}',
    debit_card_deposit: 'Se acepta tarjeta de débito para depósitos',
    fast_track_included: 'Acceso rápido incluido',
    view_all: 'Ver todo',
};
